module.exports = "https://www.gc-pro.gnp.com.mx/a3c360400b3333b8e698b709998c5814.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/dbk-nwb-validacion.png
// module id = 1815
// module chunks = 0